import { Button, Modal } from '../ui';
import './authentication-error-modal.scss';
import { redirectToLogin } from '../../lib/auth';

const AuthenticationErrorModal = () => {
  return (
    <Modal className="authentication-error-modal">
      <div className="authentication-error-modal__title">
        You&apos;ve been signed out or your access has expired.
      </div>
      <p className="authentication-error-modal__body">
        <Button
          theme="link"
          onClick={() => redirectToLogin()}
          className="authentication-error-modal__link"
        >
          Please log in again to refresh your session.
        </Button>
        <br />
      </p>
    </Modal>
  );
};

export const ID = 'Overlays.AUTHENTICATION_ERROR_MODAL';

export default AuthenticationErrorModal;
